<template>
  <div class="page">
    <div class="top-content">
      <div class="content" v-if="app_type == 1">
        此处设置商户的分账规则，只能选择往来商户里的商户，设置商户的分账百分比，也可全部分给自己，每条规则里其它商户分配的百分比之和是100%，小于或者大于100%分账规则都不能成立。最多只能设置10条分账规则，每次只能启用一条规则。
      </div>
      <div class="content" v-if="app_type == 2">
        <p>1.此处按分账渠道（支付渠道）设置各渠道的分账规则，每个渠道的分账规则可设置多个，但一次只能启用一个。</p>
        <p>
          2.渠道的主商户不参与分账，其他关联分账商户按百分比分配收入的30%，即每条分账规则中其它商户分配到的百分比之和等于30%，大于或小于30%分账规则不能成立。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RTip',
  inject: ['app_type'],
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.top-content {
  background-color: #fff;
  font-size: 14px;
  padding: 15px 20px;
  border-radius: 5px;
  .content {
    color: #666;
    line-height: 20px;
  }
}
</style>
